import React from 'react';
import PropTypes from 'prop-types';

const dropOffLocationProp = PropTypes.shape({
  address: PropTypes.shape({
    city: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
  }).isRequired,
  distance: PropTypes.number.isRequired,
  geoPosition: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  locationId: PropTypes.string,
  name: PropTypes.string.isRequired,
  operatingHours: PropTypes.arrayOf(
    PropTypes.shape({
      dayOfWeek: PropTypes.string,
      closeHours: PropTypes.string,
      openHours: PropTypes.string,
    }),
  ),
  providerType: PropTypes.string.isRequired,
});

const propTypes = {
  dropOffLocations: PropTypes.arrayOf(dropOffLocationProp).isRequired,
  MapComponent: PropTypes.func.isRequired,
  MapMarkerComponent: PropTypes.func.isRequired,
  mapComponentProps: PropTypes.shape({
    defaultDropOffLocationMapCenter: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }).isRequired,
    mapApiKey: PropTypes.string.isRequired,
    mapOptions: PropTypes.shape({
      defaultZoom: PropTypes.number.isRequired,
      zoomControl: PropTypes.bool.isRequired,
      mapTypeControl: PropTypes.bool.isRequired,
      scaleControl: PropTypes.bool.isRequired,
      streetViewControl: PropTypes.bool.isRequired,
      rotateControl: PropTypes.bool.isRequired,
      fullscreenControl: PropTypes.bool.isRequired,
      clickableIcons: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  mapMarkerPropsBuilderMethod: PropTypes.func.isRequired,
  onMarkerClick: PropTypes.func.isRequired,
};

export default function DropOffLocationMap({
  dropOffLocations,
  MapComponent,
  MapMarkerComponent,
  mapComponentProps,
  mapMarkerPropsBuilderMethod,
  onMarkerClick,
}) {
  return (
    <MapComponent
      bootstrapURLKeys={{ key: mapComponentProps.mapApiKey }}
      defaultCenter={{
        lat: mapComponentProps.defaultDropOffLocationMapCenter.latitude,
        lng: mapComponentProps.defaultDropOffLocationMapCenter.longitude,
      }}
      yesIWantToUseGoogleMapApiInternals
      defaultZoom={mapComponentProps.mapOptions.defaultZoom}
      options={{
        zoomControl: mapComponentProps.mapOptions.zoomControl,
        mapTypeControl: mapComponentProps.mapOptions.mapTypeControl,
        scaleControl: mapComponentProps.mapOptions.scaleControl,
        streetViewControl: mapComponentProps.mapOptions.streetViewControl,
        rotateControl: mapComponentProps.mapOptions.rotateControl,
        fullscreenControl: mapComponentProps.mapOptions.fullscreenControl,
        clickableIcons: mapComponentProps.mapOptions.clickableIcons,
      }}
    >
      {
        dropOffLocations.map((location) => {
          const markerProps = mapMarkerPropsBuilderMethod(location);
          return (
            <MapMarkerComponent
              key={markerProps.key}
              label={markerProps.label}
              lat={markerProps.latitude}
              lng={markerProps.longitude}
              onMarkerClick={() => onMarkerClick(location)}
            />
          );
        })
      }
    </MapComponent>
  );
}
DropOffLocationMap.propTypes = propTypes;
